<template>
  <div class="ppt-template">
    <el-dialog
      width="1080px"
      custom-class="ppt-template-dialog"
      :show-close="false"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div slot="title" class="dialog-header">
        <span class="goback" data-track-text="返回PPT模板选择" aria-label="返回PPT模板选择" @click="dialogVisible = false">
          <i class="icon"></i>返回
        </span>
        <span class="title">挑选心仪模版</span>
        <span class="filter" data-track-text="筛选" aria-label="筛选" @click="changeShowFilter"></span>
      </div>
      <div class="container">
        <div class="filter-container" v-show="isShowFilter">
          <div class="industrie filter-item">
            <span class="title">场景</span>
            <span
              class="industrie-item item"
	              :class="[item === PPTOption.industrie ? 'select' : '']"
	              v-for="item in templateOptionsAll.industries"
	              :key="item"
	              :data-track-text="`筛选PPT场景${item}`"
	              :aria-label="`筛选PPT场景${item}`"
	              @click="changeFilter('industrie', item)"
            >
              {{ item }}
            </span>
          </div>
          <div class="color filter-item">
            <span class="title">颜色</span>
            <span
              class="color-item item"
	              :class="[item === PPTOption.color ? 'select' : '']"
	              v-for="item in templateOptionsAll.colors"
	              :key="item"
	              :data-track-text="`筛选PPT颜色${item}`"
	              :aria-label="`筛选PPT颜色${item}`"
	              @click="changeFilter('color', item)"
            >
              {{ item }}
            </span>
          </div>
          <div class="style filter-item">
            <span class="title">风格</span>
            <span
              class="style-item item"
	              :class="[item === PPTOption.style ? 'select' : '']"
	              v-for="item in templateOptionsAll.styles"
	              :key="item"
	              :data-track-text="`筛选PPT风格${item}`"
	              :aria-label="`筛选PPT风格${item}`"
	              @click="changeFilter('style', item)"
            >
              {{ item }}
            </span>
          </div>
        </div>
        <div
          class="template-container"
          :style="{ height: isShowFilter ? '300px' : '470px' }"
        >
          <!-- <el-scrollbar class="template-scrollbar"> -->
          <img
            class="template-item"
            :class="[
              item.templateIndexId === currentTemplate.templateIndexId
                ? 'select'
                : '',
            ]"
            v-for="item in templateList"
            :key="item.templateIndexId"
            :src="item.detailImage.titleCoverImage"
            alt=""
            data-track-text="选择PPT模板"
            aria-label="选择PPT模板"
            @click="selectTemplate(item)"
          />
          <!-- </el-scrollbar> -->
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
	        <div class="btn" data-track-text="确认PPT模板" aria-label="确认PPT模板" @click="createPPTOutline">
          {{ btnText }}
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "PPTTemplate",
  components: {},
  props: {
    btnText: {
      type: String,
      default: "确定",
    },
  },
  data() {
    return {
      dialogVisible: false,
      PPTOption: {},
      templateList: [],
      currentTemplate: {},
      templateOptions: {},
      isShowFilter: true,
    };
  },
  computed: {
    templateOptionsAll() {
      const templateOptionsAll = {};
      Object.keys(this.templateOptions).forEach((key) => {
        templateOptionsAll[key] = ["全部", ...this.templateOptions[key]];
      });
      return templateOptionsAll;
    },
  },
  watch: {},
  mounted() {},
  methods: {
    changeShowFilter() {
      this.isShowFilter = !this.isShowFilter;
    },
    show(option) {
      this.currentTemplate = option.selectTemplate || {};
      this.dialogVisible = true;
      this.PPTOption = option.filters;
      this.templateOptions = option.templateOptions;
      this.getTemplateList();
    },
    changeFilter(key, item) {
      console.log(12);
      this.PPTOption[key] = item;
      this.getTemplateList();
    },
    createPPTOutline() {
      if (!this.currentTemplate.templateIndexId) {
        this.$message.info("请选择模板");
        return;
      }
      this.$emit("commit", {
        filters: this.PPTOption,
        templateOptions: this.templateOptions,
        selectTemplate: this.currentTemplate,
      });
      this.dialogVisible = false;
    },
    selectTemplate(template) {
      this.currentTemplate = template;
    },
    getTemplateList() {
      const PPTOption = {
        ...this.PPTOption,
      };
      delete PPTOption.fileList;
      PPTOption.industrie =
        PPTOption.industrie === "全部" ? "" : PPTOption.industrie;
      PPTOption.color = PPTOption.color === "全部" ? "" : PPTOption.color;
      PPTOption.style = PPTOption.style === "全部" ? "" : PPTOption.style;
      this.$http
        .get("/chatApi/v1/chatPpt/templateList", {
          params: PPTOption,
        })
        .then((res) => {
          this.templateList = res.data.data.records.map((item) => {
            return {
              ...item,
              detailImage: JSON.parse(item.detailImage),
            };
          });
          console.log(444, this.templateList);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.ppt-template {
  .dialog-header {
    position: relative;
    padding: 10px 20px;
    .goback {
      display: inline-block;
      width: 120px;
      height: 44px;
      font-size: 16px;
      color: var(--foreground-secondary);
      line-height: 44px;
      background: var(--bg-subtle);
      border-radius: var(--radius-sm);
      cursor: pointer;
      text-align: center;
      i {
        display: inline-block;
        width: 24px;
        height: 20px;
        vertical-align: middle;
        background: url(../../assets/chat/back.png) left no-repeat;
        background-size: contain;
        filter: invert(42%) sepia(93%) saturate(2476%) hue-rotate(121deg) brightness(95%) contrast(101%);
      }
    }
    .title {
      display: inline-block;
      font-weight: 600;
      font-size: 24px;
      color: var(--foreground);
      margin-left: 36px;
      height: 44px;
      line-height: 44px;
      vertical-align: bottom;
    }
    .filter {
      position: absolute;
      top: 12px;
      right: 10px;
      width: 18px;
      height: 18px;
      background: url(../../assets/chat/filter.png) center no-repeat;
      background-size: contain;
      filter: invert(42%) sepia(93%) saturate(2476%) hue-rotate(121deg) brightness(95%) contrast(101%);
      cursor: pointer;
    }
  }
  /deep/.el-dialog__body {
    padding: 20px;
  }
  .container {
    height: 472px;
    padding: 0 20px;
    margin-top: 0px;
    .filter-container {
      margin-bottom: 20px;
      .filter-item {
        margin-bottom: 14px;
        .title {
          display: inline-block;
          font-size: 14px;
          color: var(--foreground-secondary);
          padding: 6px 16px;
        }
        .item {
          display: inline-block;
          font-size: 14px;
          color: var(--foreground-secondary);
          padding: 6px 12px;
          cursor: pointer;
          transition: background-color .15s, color .15s;
          &.select {
            background: var(--primary-alpha-08);
            border-radius: 13px;
            color: var(--primary);
          }
        }
      }
    }
    .template-container {
      padding-left: 10px;
      display: flex;
      gap: 26px;
      flex-wrap: wrap;
      overflow: auto;
      .template-item {
        box-sizing: border-box;
        width: 220px;
        height: 124px;
        cursor: pointer;
        border-radius: var(--radius-md);
        border: 1px solid var(--border);
        &.select {
          border: 2px solid var(--primary);
        }
      }
    }
  }
  .dialog-footer {
    .btn {
      width: 220px;
      height: 40px;
      background: var(--primary);
      border-radius: var(--radius-md);
      cursor: pointer;
      transition: background-color .15s, box-shadow .15s;

      &:hover {
        background: var(--primary-dark);
        box-shadow: var(--shadow-primary);
      }
      font-size: 16px;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      margin: 0 auto;
    }
  }
}

@media (min-width: 768.01px) {
  .ppt-template {
    /deep/ .ppt-template-dialog {
      display: flex;
      flex-direction: column;
      width: calc(100vw - 200px) !important;
      height: calc(100vh - 64px);
      max-width: none;
      max-height: none;
      margin: 64px 0 0 200px !important;
      overflow: hidden;
      box-sizing: border-box;
    }

    /deep/ .ppt-template-dialog .el-dialog__header {
      flex: 0 0 auto;
      padding: 14px 20px;
    }

    /deep/ .ppt-template-dialog .el-dialog__body {
      display: flex;
      flex: 1 1 auto;
      min-height: 0;
      padding: 0 20px;
      overflow: hidden;
    }

    /deep/ .ppt-template-dialog .el-dialog__footer {
      flex: 0 0 auto;
      padding: 14px 20px 18px;
    }

    .dialog-header {
      padding: 0;
    }

    .container {
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      width: 100%;
      height: 100%;
      min-height: 0;
      padding: 0;

      .filter-container {
        flex: 0 0 auto;
        max-height: 190px;
        margin-bottom: 12px;
        overflow-y: auto;
      }

      .template-container {
        display: grid;
        flex: 1 1 auto;
        grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
        align-content: start;
        gap: 20px;
        height: auto !important;
        min-height: 0;
        padding: 8px;
        overflow-y: auto;

        .template-item {
          width: 100%;
          height: auto;
          aspect-ratio: 16 / 9;
          object-fit: cover;
        }
      }
    }
  }
}

/* PPT 模板选择弹窗在手机端占满可用视口。 */
@media (max-width: 768px) {
  .ppt-template {
    /deep/ .ppt-template-dialog {
      display: flex;
      flex-direction: column;
      width: calc(100vw - 24px) !important;
      height: calc(100dvh - 24px);
      max-height: calc(100dvh - 24px);
      margin: 12px auto !important;
      overflow: hidden;
      box-sizing: border-box;
    }

    /deep/ .ppt-template-dialog .el-dialog__header {
      flex: 0 0 auto;
      padding: 10px 12px;
    }

    /deep/ .ppt-template-dialog .el-dialog__body {
      display: flex;
      flex: 1 1 auto;
      min-height: 0;
      padding: 0 12px;
      overflow: hidden;
    }

    /deep/ .ppt-template-dialog .el-dialog__footer {
      flex: 0 0 auto;
      padding: 10px 12px 12px;
    }

    .dialog-header {
      display: grid;
      grid-template-columns: 74px minmax(0, 1fr) 32px;
      align-items: center;
      gap: 8px;
      padding: 0;

      .goback {
        width: 74px;
        height: 36px;
        font-size: 14px;
        line-height: 36px;

        i {
          width: 18px;
          height: 16px;
        }
      }

      .title {
        width: auto;
        height: 36px;
        margin: 0;
        overflow: hidden;
        text-align: center;
        text-overflow: ellipsis;
        font-size: 18px;
        line-height: 36px;
        white-space: nowrap;
      }

      .filter {
        position: static;
        justify-self: center;
      }
    }

    .container {
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      width: 100%;
      height: 100%;
      min-width: 0;
      min-height: 0;
      padding: 0;

      .filter-container {
        flex: 0 0 auto;
        max-height: 32dvh;
        margin-bottom: 8px;
        overflow-y: auto;

        .filter-item {
          margin-bottom: 8px;

          .title,
          .item {
            padding: 5px 8px;
            font-size: 13px;
          }
        }
      }

      .template-container {
        display: grid;
        flex: 1 1 auto;
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
        align-content: start;
        gap: 12px;
        height: auto !important;
        min-height: 0;
        padding: 4px;
        overflow-y: auto;

        .template-item {
          width: 100%;
          height: auto;
          aspect-ratio: 16 / 9;
          object-fit: cover;
        }
      }
    }

    .dialog-footer .btn {
      width: 100%;
      max-width: 220px;
    }
  }
}
</style>
